// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"cd7fcfab","952":"e145aacc"}[chunkId] + ".chunk.js";
};